<template>
    <div class="subs content-container">
        <div class="header">
            <div class="title">Communications</div>
        </div>        
        <div class="content">
            <div class="subscription-table">
                <subscription-header-row/>
                <subscription-message-group :messages="profile.messages"/>
                <subscription-board-group @refresh="refresh" :boardCategories="profile.boardCategories"/>
                <subscription-topic-group :topicsBoardCat="profile.topicBoardCategories"/>              
            </div>
        </div>
    </div>
</template>

<script>
    import api from '../../api/api';
    import SubscriptionHeaderRow from './Subscription/SubscriptionHeaderRow.vue';
    import SubscriptionBoardGroup from './Subscription/SubscriptionBoardGroup.vue';
    import SubscriptionTopicGroup from './Subscription/SubscriptionTopicGroup.vue';
    import SubscriptionMessageGroup from './Subscription/SubscriptionMessageGroup.vue';
    import SubscriptionMentionsGroup from "./Subscription/SubscriptionMentionsGroup.vue";

    export default {
        components: {
            SubscriptionHeaderRow,
            SubscriptionBoardGroup,
            SubscriptionTopicGroup,
            SubscriptionMessageGroup,
            SubscriptionMentionsGroup
        },
        data() {
            return {
                profile: {},
                topics: null,
                boards: null,
                messages: null,
            };
        },
        created() {
            api.get('/Subscription/profile').then(r=> {
                this.profile = {};
                this.profile = r.data;
                this.topics = this.profile.TopicBoardCategories;
                this.boards = this.profile.boards;
                this.messages = this.profile.messages;
            });
        },
        methods: {
          refresh() {
            api.get('/Subscription/profile').then(r=> {
              this.profile = r.data;
              this.$forceUpdate();
            });
          },
        },
    }
</script>
